<template>
  <b-modal
    :id="modalId"
    title="Условия предоставления услуги"
  >
    <div slot="modal-header">
      <button type="button" class="close" aria-label="Close" @click="closeModal">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title">Условия предоставления услуги</h4>
    </div>
    <div v-html="textOffer"/>
    <template
      v-slot:modal-footer
    >
      <button type="button" class="btn btn-default btn-primary-white" @click="closeModal">Закрыть</button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'OfferModal',

  props: {
    modalId: {
      type: String,
      default: 'modal-offer'
    },

    textOffer: {
      type: String,
      requried: true
    }
  },

  methods: {
    closeModal () {
      this.$bvModal.hide(this.modalId)
    }
  }
}
</script>
